<template>
  <b-button
    class="js-open-signup-popup w-full m:w-72"
    @click="isUserLoggedIn ? goToNameInputPage() : null"
    :data-login-path="loginPath"
    :data-signup-path="signupPath"
  >
    {{ $t("joinSpace") }}
  </b-button>
</template>

<script>
import BButton from "@/component-library/b-button"
import { mapGetters } from "vuex"
import { go, safeAppendToUrl } from "@/utils/location"

export default {
  name: "JoinButton",
  components: {
    BButton
  },
  props: {
    loginPath: {
      type: String,
      required: true
    },
    signupPath: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["isUserLoggedIn"])
  },
  methods: {
    goToNameInputPage() {
      go(safeAppendToUrl("/accept"))
    }
  },
  i18n: {
    messages: {
      en: {
        joinSpace: "Join Space"
      },
      de: {
        joinSpace: "Space beitreten"
      }
    }
  }
}
</script>
